import React from "react";
import { PageHero, PageBody } from "./_shared";
import { usePoly } from "./PolyLayout";
import BodyMembersTable from "@/components/BodyMembersTable";

export default function GoverningBodyPage() {
  const data = usePoly();
  const list = data.governing_body || [];
  return (
    <div data-testid="poly-gb-page-wrap">
      <PageHero eyebrow="About" title="Governing Body Members" />
      <PageBody>
        <BodyMembersTable members={list} theme="amber" testidPrefix="poly-gb-page" />
      </PageBody>
    </div>
  );
}
